import { render, staticRenderFns } from "./BedMeshChart.vue?vue&type=template&id=40495ab7&scoped=true&"
import script from "./BedMeshChart.vue?vue&type=script&lang=ts&"
export * from "./BedMeshChart.vue?vue&type=script&lang=ts&"
import style0 from "./BedMeshChart.vue?vue&type=style&index=0&id=40495ab7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40495ab7",
  null
  
)

export default component.exports